module.exports = __webpack_public_path__ + "img/qr-code-test.1d65e256.png";